const Car = () => (
  <svg focusable={false} xmlns='http://www.w3.org/2000/svg' viewBox='0 0 48 48'>
    <g fill='none' fillRule='evenodd'>
      <circle cx={24} cy={24} r={20} fill='#E3E6E8' />
      <path
        fill='#FFF'
        fillRule='nonzero'
        d='M33.094 20.175l-1.721-4.555c-.322-.872-1.026-1.614-2.357-1.62H19.97c-1.325.006-2.028.748-2.356 1.62l-1.722 4.555c-.683.09-1.893.913-1.891 2.473v5.8h1.68v1.85c-.004 2.283 3.147 2.256 3.147 0v-1.85H30.16v1.85c.006 2.256 3.158 2.283 3.16 0v-1.85H35v-5.8c-.005-1.56-1.216-2.383-1.906-2.473zm-15.791 4.772c-.805.003-1.457-.685-1.454-1.532-.003-.852.649-1.54 1.454-1.534.802-.007 1.454.682 1.453 1.534.001.847-.65 1.535-1.453 1.532zm7.197-4.815h-6.816l1.298-3.587c.156-.509.4-.873.974-.882H29.044c.566.009.81.373.974.882l1.298 3.587H24.5zm7.198 4.815c-.811.003-1.464-.685-1.468-1.532.004-.852.657-1.54 1.468-1.534.796-.007 1.448.682 1.453 1.534-.005.847-.657 1.535-1.453 1.532z'
      />
    </g>
  </svg>
);

export default Car;
